import { HomeFeaturedCardContext } from '@app/domains/home/components/HomeFeaturedCard';
import { useContext } from 'react';

export default function GradationLayer() {
    const { cardColor } = useContext(HomeFeaturedCardContext);
    return (
        <div
            style={{ backgroundImage: `linear-gradient(to top, ${cardColor}, ${cardColor}00)` }}
            className="h-full"
        ></div>
    );
}
